export default "__VITE_ASSET__d6d4d0f1__"